// extracted by mini-css-extract-plugin
module.exports = {"rules":"styles_rules__1E1nh","more":"styles_more__35Rnd"};